import {
  ref,
  computed,
  reactive,
  // watch,
  // xxx
} from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
// import axios from 'axios'
import {
  URL,
  URL_CARNET,
  USER,
  INSERT_DATA_PLAYER,
  INSERT_DATA_HISTORY_PLAYER,
  UPDATE_DATA_PLAYER,
  ESTADO_JUGADOR,
} from '../../utils/variables'
import apiCall from '../../utils/apiCall'

export default function useInscription() {
  const { getApi, postApi } = apiCall()
  const listEquipos = ref([])
  const listJugadores = ref([])
  const listJugadoresPases = ref([])
  const listJugadoresSearch = ref([])
  const listCategoriasAdmin = ref([])
  const listPositions = ref([])
  const listTiposAdicionales = ref([])
  const listHistorialCampeonatos = ref([])
  const selectedPrint = ref([])
  const searchQuery = ref('')
  const searchQueryPases = ref('')
  // const totalInscritos= ref(0)
  // const totalRevisados= ref(0)
  const categoriaAdmin = ref(null)
  const categoriaSeleccionada = ref({ label: 'Seleccione Equipo', isInReview: false })
  const refInvoiceListTable = ref(null)
  const showLoading = ref(false)
  const showLoadingPases = ref(false)
  const playerData = reactive({
    apellidos: '',
    ci_pasaporte: '',
    direccion: null,
    email: null,
    fecha_nac: '',
    id_disciplina: '',
    id_equipo: '',
    nombres: '',
    num_camiseta: '',
    id_historial: '',
    observaciones: null,
    posicion: {
      label: 'Posicion',
      value: null,
    },
    tipo_adicional: {
      label: 'Tipo Jugador',
      value: null,
    },
    posicionAuxiliar: {
      label: 'Posicion',
      value: null,
    },
    telefono: null,
    tipo_jugador: '',
    estado_jug: 'inscrito',
    id_jugador: null,
    vacuna: null,
    dataCategoria: {
      facialWeb: false,
    },
    archivos_jugador: [],
  })
  // const playerSelected = reactive({})

  const tableColumns = [
    {
      key: 'num_camiseta',
      label: '#',
      stickyColumn: true,
      sortable: true,
    },
    // { key: 'have_face', label: 'F', sortable: true },
    { key: 'jugador', sortable: true },
    { key: 'fecha_nac', label: 'Fecha.Nacimiento', sortable: true },
    { key: 'categoria', sortable: true },
    { key: 'tipo_jugador', label: 'T.J', sortable: true },
    { key: 'estado_jug', sortable: true },
    { key: 'acciones' },
  ]
  const tableColumnsPases = [
    { key: 'id_pase', label: 'Id', sortable: true },
    { key: 'jugador', sortable: true },
    { key: 'fecha', sortable: true },
    { key: 'tipo_pase_text', sortable: true },
    { key: 'equipo_sale', label: 'Emite', sortable: true },
    { key: 'equipo_entra', label: 'Recibe', sortable: true },
    { key: 'acciones' },
  ]

  async function getListCategoriasAdmin(idTorneo) {
    listCategoriasAdmin.value = []
    const path = `ApiConfiguration/getCategoriasEquipos/${idTorneo}`
    const data = await getApi(URL, path)
    if (data.flag === 's') {
      data.data.forEach(element => {
        const obj = {
          label: `${element.disciplina} ${element.categoria}`,
          value: element.id_categoria,
          campeonato: element.campeonato,
          equipos: element.equipos,
          id_categoria: element.id_categoria,
          id_disciplina: element.id_disciplina,
          tieneClasificado: element.tieneClasificado,
          agrupar: element.agrupar,
          agrupacion_pase: element.agrupacion_pase,
          data_categoria: {
            tieneJuvenil: element.tiene_juvenil,
            fechaMinJuvenil: element.fecha_min_juvenil,
            fechaMaxJuvenil: element.fecha_max_juvenil,
            validarPorAnios: element.valida_por_anios,
            limitesAnios: element.limites_anios,
            facialWeb: element.facialWeb,
            fechaMinJuvenilDos: element.fecha_limite_hasta_juvenil_dos,
            tieneJuvenilDos: element.tiene_juvenil_dos,
          },
          validations: element.validaciones,
        }
        listCategoriasAdmin.value.push(obj)
      })
    } else {
      listCategoriasAdmin.value = []
    }
  }
  function changeCategoriaAdmin() {
    listEquipos.value = []
    categoriaSeleccionada.value = { label: 'Seleccione Equipo', isInReview: false }
    listJugadores.value = []
    playerData.id_equipo = ''
    // console.log(categoriaAdmin)
    const filtroCategoria = listCategoriasAdmin.value.filter(categoria => categoria.value === categoriaAdmin.value.value)
    const flitroUsar = filtroCategoria[0]
    // console.log(flitroUsar)
    const dataCategoriaUsar = flitroUsar.data_categoria
    flitroUsar.equipos.forEach(element => {
      const obj = {
        label: `${element.apodo} ${element.alias_equipo}`,
        value: element.id_equipo,
        id_categoria: flitroUsar.id_categoria,
        id_disciplina: flitroUsar.id_disciplina,
        isOpen: true,
        validations: flitroUsar.validations,
        data_categoria: dataCategoriaUsar,
        tieneClasificado: flitroUsar.tieneClasificado,
        campeonato: flitroUsar.campeonato,
      }
      listEquipos.value.push(obj)
    })
  }
  async function getCategoriasEditar() {
    const path = `ApiInscripciones/getCategoriasEdicionUsuario/${USER().id_usuario}/${store.getters['someVariables/getTorneoSeleccionado'].id_torneo}`
    const data = await getApi(URL, path)
    if (data.flag === 's') {
      data.categoriaInst.forEach(element => {
        const obj = {
          label: `${element.disciplina} ${element.categoria} ${element.institucion} ${element.equipo}`,
          value: element.id_equipo,
          id_disciplina: element.id_disciplina,
          id_categoria: element.id_categoria,
          isOpen: element.isOpen,
          isInReview: element.isInReview,
          finalizaEn: element.finalizaEn,
          validations: element.validaciones,
          tieneClasificado: element.tiene_clasificado,
          campeonato: element.campeonato,
          data_categoria: {
            tieneJuvenil: element.tiene_juvenil,
            fechaMinJuvenil: element.fecha_min_juvenil,
            fechaMaxJuvenil: element.fecha_max_juvenil,
            validarPorAnios: element.valida_por_anios,
            limitesAnios: element.limites_anios,
            fechaMinJuvenilDos: element.fecha_limite_hasta_juvenil_dos,
            tieneJuvenilDos: element.tiene_juvenil_dos,
          },
        }
        listEquipos.value.push(obj)
      })
    } else {
      listEquipos.value = []
    }
  }
  async function getHistorialCampeonatos(idTorneo) {
    listHistorialCampeonatos.value = []
    const path = `ApiConfiguration/getHistorialCampeonatos/${idTorneo}`
    const data = await getApi(URL, path)
    if (data.flag === 's') {
      data.data.forEach(element => {
        const obj = {
          label: `${element.anio_inic} - ${element.anio_fin}`,
          value: element.id_campeonato,
        }
        listHistorialCampeonatos.value.push(obj)
      })
      // console.log(listHistorialCampeonatos.value)
    } else {
      listHistorialCampeonatos.value = []
    }
  }
  async function getJugadores(idEquipo) {
    listJugadores.value = []
    showLoading.value = true
    const path = `ApiInscripciones/getJugadoresIdEquipo/${idEquipo}`
    const data = await getApi(URL, path)
    if (data.flag === 's') {
      listJugadores.value = data.data
    } else {
      listJugadores.value = []
    }
    showLoading.value = false
  }
  async function getJugadoresPases(idTorneo) {
    listJugadoresPases.value = []
    showLoadingPases.value = true
    const path = `ApiInscripciones/getLibroPases/${idTorneo}`
    const data = await getApi(URL, path)
    listJugadoresPases.value = data
    showLoadingPases.value = false
  }

  async function getJugadoresCedula(cedula, idDisciplina) {
    listJugadoresSearch.value = []
    const path = `ApiInscripciones/getJugadoresCedula/${cedula}/${idDisciplina}`
    const data = await getApi(URL, path)
    if (data.flag === 'si') {
      listJugadoresSearch.value = data.data
    } else {
      listJugadoresSearch.value = []
    }
  }
  async function getPositionsDiscipline(idDisciplina, idCategoria) {
    listPositions.value = []
    listTiposAdicionales.value = []
    const path = `ApiInscripciones/getPosicionesJugador/${idDisciplina}/${idCategoria}`
    const data = await getApi(URL, path)
    if (data.posiciones.length !== 0) {
      data.posiciones.forEach(element => {
        const obj = {
          label: `${element.posicion}`,
          value: element.id_posicion,
        }
        listPositions.value.push(obj)
      })
    } else {
      listPositions.value = []
    }
    if (data.tipos_adicional.length !== 0) {
      data.tipos_adicional.forEach(element => {
        const obj = {
          label: `${element.tipo_alterno}`,
          value: element.tipo_alterno,
        }
        listTiposAdicionales.value.push(obj)
      })
    } else {
      listTiposAdicionales.value = []
    }
  }
  const listPlayersFilter = computed(() => listJugadores.value.filter(
    player => player.nombres
      .toLowerCase()
      .includes(searchQuery.value.toLowerCase())
      // eslint-disable-next-line
      || player.apellidos
        .toLowerCase()
        .includes(searchQuery.value.toLowerCase())
      // eslint-disable-next-line
      || player.ci_pasaporte
        .toLowerCase()
        .includes(searchQuery.value.toLowerCase()),
  ))
  const listPlayersFilterPases = computed(() => listJugadoresPases.value.filter(
    player => player.nombres
      .toLowerCase()
      .includes(searchQueryPases.value.toLowerCase())
      // eslint-disable-next-line
      || player.apellidos
        .toLowerCase()
        .includes(searchQueryPases.value.toLowerCase())
      // eslint-disable-next-line
      || player.ci_pasaporte
        .toLowerCase()
        .includes(searchQueryPases.value.toLowerCase())
      // eslint-disable-next-line
      || player.cat_entra?.toLowerCase().includes(searchQueryPases.value.toLowerCase())
      // eslint-disable-next-line
      || player.cat_sale?.toLowerCase().includes(searchQueryPases.value.toLowerCase())
      // eslint-disable-next-line
      || player.equipo_entra?.toLowerCase().includes(searchQueryPases.value.toLowerCase())
      // eslint-disable-next-line
      || player.equipo_sale?.toLowerCase().includes(searchQueryPases.value.toLowerCase())
      // eslint-disable-next-line
      || player.tipo_pase_text?.toLowerCase().includes(searchQueryPases.value.toLowerCase()),
  ))

  const totalCalificados = computed(() => listPlayersFilter.value.filter(element => element.estado_jug === ESTADO_JUGADOR.CALIFICADO && element.is_activo === true).length)
  const totalRevisados = computed(() => listPlayersFilter.value.filter(element => element.estado_jug === ESTADO_JUGADOR.REVISADO).length)
  const totalInscritos = computed(() => listPlayersFilter.value.filter(element => element.estado_jug === ESTADO_JUGADOR.INSCRITO).length)
  const totalInactivos = computed(() => listPlayersFilter.value.filter(element => element.estado_jug === ESTADO_JUGADOR.CALIFICADO && element.is_activo === false).length)
  function changeCategoria(item) {
    // console.log(item)
    categoriaSeleccionada.value = item
    getJugadores(item.value)
    getPositionsDiscipline(item.id_disciplina, item.id_categoria)
    playerData.id_equipo = item.value
    playerData.id_disciplina = item.id_disciplina
    playerData.validations = item.validations
    playerData.dataCategoria = item.data_categoria
    playerData.isOpen = item.isOpen
    playerData.isInReview = item.isInReview
    playerData.finalizaEn = item.finalizaEn
    playerData.tieneClasificado = item.tieneClasificado
    // console.log(categoriaSeleccionada.value)
  }
  async function updateFacialId(item) {
    const path = 'ApiInscripciones/updateFacialId'
    const data = { id_jugador: item.id_jugador }
    const response = await postApi(URL, path, data)
    if (response.flag === 'si') {
      const found = listPlayersFilter.value.findIndex(
        // eslint-disable-next-line
        element => element.id_jugador === item.id_jugador
      )
      listPlayersFilter.value[found].have_face = true
      // listCategorias.value[found].valores_fijos.push(item)
      // console.log(playerData)
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Facial Id generado',
            icon: 'AlertCircleIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        }
      )
    } else {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: `ERROR ${response.mensaje}`,
            icon: 'AlertCircleIcon',
            variant: 'danger',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        }
      )
    }
  }
  async function insertSolicitudRevision() {
    const path = 'ApiInscripciones/insertSolicitudInscripcion'
    const response = await postApi(URL, path, playerData.id_equipo)
    if (response.flag === 'si') {
      playerData.isInReview = true
      // listEquipos.value[0].isInReview = true
      categoriaSeleccionada.value.isInReview = true
      // console.log(playerData)
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'SOLICITUD de REVISIÓN enviada exitosamente',
            icon: 'AlertCircleIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        }
      )
    } else {
      playerData.isInReview = false
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'ERROR no se pudo enviar',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        }
      )
    }
  }
  function salirRevision() {
    store.commit('someVariables/UPDATE_ACTIVATE_REVISION', false)
    listJugadores.value = []
    categoriaSeleccionada.value = { label: 'Seleccione Equipo', isInReview: false }
    categoriaAdmin.value = null
    playerData.id_equipo = ''
  }
  function hayNoCalificados(tipo) {
    let hay = false
    let found
    if (tipo === 'seleccion') {
      // console.log(selectedPrint.value)
      found = selectedPrint.value.find(element => (element.estado_jug === ESTADO_JUGADOR.REVISADO || element.estado_jug === ESTADO_JUGADOR.INSCRITO))
    }
    if (found !== undefined) {
      hay = true
    }
    return hay
  }
  function isEmptyLista(tipo) {
    let noHay = false
    if (tipo === 'todos') {
      if (listPlayersFilter.value.length === 0) {
        noHay = true
      }
    } else if (tipo === 'seleccion') {
      if (selectedPrint.value.length === 0) {
        noHay = true
      }
    }
    return noHay
  }
  function dataCarnet(tipo) {
    let data
    if (tipo === 'todos') {
      const result = listPlayersFilter.value.filter(element => element.estado_jug === ESTADO_JUGADOR.CALIFICADO && element.is_activo)
      data = result
    } else if (tipo === 'seleccion') {
      data = selectedPrint.value
    }
    return data
  }
  async function printCarnets(tipo) {
    if (isEmptyLista(tipo)) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Debe seleccionar almenos un jugador para imprimir',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        }
      )
    } else if (hayNoCalificados(tipo)) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Eliga solo jugadores calificados',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        }
      )
    } else {
      const data = dataCarnet(tipo)
      const dataSend = {
        carnets: data,
        id_user: USER().id_usuario,
        idTorneo: store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
      }
      const path = `ApiInscripciones/imprimeCarnets/${categoriaAdmin.value.value}`
      await postApi(URL, path, dataSend)
      window.open(`${URL_CARNET}carnets1.pdf?v=${Math.random() * 100}`, '_blank')
      // if (response.flag === 'si') {
    }
  }
  function getTotal() {
    const list = listPlayersFilter.value.filter(element => element.estado_jug === ESTADO_JUGADOR.CALIFICADO)
    return list.length
  }
  // async function updateSolicitudRevision(idInscripcion) {
  //   const path = 'ApiConfiguration/updateInscripcionEquipo'
  //   const response = await postApi(URL, path, idInscripcion)
  //   if (response.flag === 'si') {
  //     this.$toast(
  //       {
  //         component: ToastificationContent,
  //         props: {
  //           title: 'REVISION EXITOSA',
  //           icon: 'AlertCircleIcon',
  //           variant: 'success',
  //           solid: true,
  //         },
  //       },
  //       {
  //         position: 'bottom-center',
  //         // eslint-disable-next-line
  //       }
  //     )
  //     salirRevision()
  //   } else {
  //     this.$toast(
  //       {
  //         component: ToastificationContent,
  //         props: {
  //           title: 'ERROR no se pudo actualizar',
  //           icon: 'AlertCircleIcon',
  //           variant: 'danger',
  //           solid: true,
  //         },
  //       },
  //       {
  //         position: 'top-center',
  //         // eslint-disable-next-line
  //       }
  //     )
  //   }
  // }
  // async function uploadExcel(fileData) {
  //   console.log(playerData.id_equipo)
  //   const archivo = new FormData()
  //   archivo.append('file', fileData)
  //   archivo.append('id_equipo', playerData.id_equipo)
  //   archivo.append('totalInscritos', 2)
  //   const path = 'ApiInscripciones/exel'
  //   const response = await postApiFormData(URL, path, archivo)
  //   console.log(response)
  // }

  return {
    tableColumns,
    listEquipos,
    listJugadores,
    listCategoriasAdmin,
    getCategoriasEditar,
    getListCategoriasAdmin,
    getJugadores,
    changeCategoria,
    searchQuery,
    refInvoiceListTable,
    listPlayersFilter,
    getJugadoresCedula,
    listJugadoresSearch,
    getPositionsDiscipline,
    listPositions,
    listTiposAdicionales,
    changeCategoriaAdmin,
    // playerSelected,
    playerData,
    INSERT_DATA_PLAYER,
    INSERT_DATA_HISTORY_PLAYER,
    UPDATE_DATA_PLAYER,
    categoriaAdmin,
    showLoading,
    insertSolicitudRevision,
    // updateSolicitudRevision,
    salirRevision,
    categoriaSeleccionada,
    printCarnets,
    selectedPrint,
    getTotal,
    totalCalificados,
    totalRevisados,
    totalInscritos,
    totalInactivos,
    getHistorialCampeonatos,
    listHistorialCampeonatos,
    tableColumnsPases,
    getJugadoresPases,
    listJugadoresPases,
    showLoadingPases,
    updateFacialId,
    listPlayersFilterPases,
    searchQueryPases,
    // uploadExcel,
  }
}
